import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: ${layout.spacing.xSmall};
  margin-top: ${layout.spacing.large};
`;

export default Title;
